import React, { useEffect, useState } from "react";
import MainButton from "../../common/buttons/mainButton/MainButton";
import { Spinner } from "react-bootstrap";
import { getAllLessons } from "../../../services/courses.service";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../common/loader/Loader";
import { Styles } from "./styles";
import i18next, { t } from "i18next";
import { useSelector } from "react-redux";
import { ActivityStatus } from "../../../enums/activityStatus";

const Join = (props) => {
  const {
    isCourseDataLoading,
    data,
    joinChannel,
    isJoined,
    isLoading,
    isActivity,
  } = props;
  const isAr = i18next.language === "ar";
  const settings = useSelector((state) => state.setting);
  const [enableJoin, setEnableJoin] = useState(false);

  const checkWithin15MinutesBeforeSessionStart = () => {
    const now = new Date().getTime();
    const dateString = data?.localizedSessionTime;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();

    const fifteenMinutesBeforeStartTime =
      realDate - settings?.settings?.JoinSessionPeriod * 60 * 1000;
    return now >= fifteenMinutesBeforeStartTime && data?.status === "Scheduled";
  };

  const checkWithin30MinutesBeforeSessionStart = () => {
    const now = new Date().getTime();
    const dateString = data?.localizedSessionTime;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();

    const fifteenMinutesBeforeStartTime =
      realDate - (settings?.settings?.JoinSessionPeriod + 15) * 60 * 1000;
    return now >= fifteenMinutesBeforeStartTime && data?.status === "Scheduled";
  };

  useEffect(() => {
    if (!isActivity && data) {
      if (checkWithin15MinutesBeforeSessionStart()) {
        setEnableJoin(true);
      }
    }
    if (!isActivity && data && !enableJoin) {
      if (checkWithin30MinutesBeforeSessionStart()) {
        const now = new Date().getTime();
        const dateString = data?.localizedSessionTime;
        const [day, month, year] = dateString.split("/");
        const formattedDate = `${month}/${day}/${year}`;
        const realDate = new Date(formattedDate).getTime();

        const enableButtonsTimer = setTimeout(() => {
          setEnableJoin(true);
        }, realDate - settings?.settings?.JoinSessionPeriod * 60 * 1000 - now);
        return () => clearTimeout(enableButtonsTimer);
      }
    }
  }, [data, settings]);

  const checkWithin15MinutesBeforeActivityStart = (ActivityTime) => {
    const now = new Date().getTime();
    const dateString = ActivityTime;
    const [day, month, year] = dateString.split("/");
    const formattedDate = `${month}/${day}/${year}`;
    const realDate = new Date(formattedDate).getTime();
    const fifteenMinutesBeforeStartTime =
      realDate - settings?.settings?.JoinWorkshopPeriod * 60 * 1000;
    if (data?.status == ActivityStatus.New) {
      if (now >= fifteenMinutesBeforeStartTime) {
        setEnableJoin(true);
      }
    } else if (data?.status == ActivityStatus.Started) {
      setEnableJoin(true);
    }
  };

  useEffect(() => {
    if (data && isActivity) {
      checkWithin15MinutesBeforeActivityStart(data?.stringWorkshopDate);
    }
  }, [data]);

  return (
    <Styles>
      {isCourseDataLoading ? (
        <div className="waiting">
          <Loader paddingTop={"20%"} />
        </div>
      ) : (
        <div className="join-data">
          {isActivity && (
            <div className="image">
              <img src={data?.image} alt={data?.localizedName} />
            </div>
          )}
          <div className="title">
            {isActivity ? data?.localizedName : data?.name}
          </div>
          {/* <div dangerouslySetInnerHTML={{ __html: data?.description }} /> */}
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: isActivity
                ? data?.localizedDescription
                : data?.description,
            }}
          ></div>
          {isActivity ? (
            <div className="session-start">{data?.stringWorkshopDate}</div>
          ) : (
            <>
              <div className="session-start">
                {t("session_start")} : {data?.localizedSessionTime}
              </div>
              <div className="session-end">
                {t("session_end")} : {data?.localizedSessionEndTime}
              </div>
            </>
          )}
          <div className="join-button">
            <MainButton
              buttonClick={() => {
                joinChannel();
              }}
              buttonDisabled={!enableJoin}
              //   buttonDisabled={
              //     isJoined ||
              //     !checkWithin15MinutesBeforeSessionStart(
              //       data?.sessionTime,
              //       data?.sessionEndTime
              //     )
              //   }
              buttonText={
                isLoading ? (
                  <Spinner size={"sm"} />
                ) : (
                  <div className="btn-text">
                    <i className="fa-solid fa-arrow-right-to-bracket"></i>
                    {t("join")}
                  </div>
                )
              }
            />
          </div>
          <div className="note">
            {t("for_join_problem")}
            <div className="link">
              <Link to={"/contact-us"}>{t("footer.contact_us")}</Link>
            </div>
          </div>
        </div>
      )}
    </Styles>
  );
};

export default Join;
